export default __webpack_public_path__ + "static/media/jupi3.0e1845b8.png";